import { http } from '@/api/http'
import type { ActivityLog } from '@/lib/pos-types'
import { normalizeActivityLog, unwrapList } from '@/api/normalizers'

export const activitiesApi = {
  list: async (params?: { since?: string; limit?: number }): Promise<ActivityLog[]> => {
    const qs = new URLSearchParams()
    if (params?.since) qs.set('since', params.since)
    if (typeof params?.limit === 'number') qs.set('limit', String(params.limit))
    const res = await http.get<unknown>(`/activities${qs.toString() ? `?${qs.toString()}` : ''}`)
    return unwrapList(res.data).map(normalizeActivityLog)
  },
}
